import React, { useEffect, useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';

import { IndependentSelect } from '~/src/dash/components/dropdowns/IndependentSelect';
import { useFormBuilderStore } from '~/src/dash/components/forms/formBuilder/contexts';
import { convertSetIntoSingleNumber } from '~/src/dash/components/forms/formBuilder/ParameterRow/editors/common/common';
import { Col, Cols, Row, Rows, spacing, Text } from '~/src/dash/publicaUI';

export const GDPRSelect = () => {
  const { object, defaultObject, lists } = useFormBuilderStore();
  const valueKey = 'TargetingGDPR';
  const selectedOptionIDsArray = [object[valueKey]];

  const consentValueKey = 'TargetingGDPRConsent';
  const selectedConsentIDsArray = [object[consentValueKey]];

  const [gdpr, setGDPR] = useState(object[valueKey]);
  const [_consent, setConsent] = useState(object[consentValueKey]);

  useEffect(() => {
    return () => {
      object[valueKey] = defaultObject[valueKey];
      object[consentValueKey] = defaultObject[consentValueKey];
    };
  }, []);

  const handleApplyGDPR = (selectedIDs: Set<number | string>) => {
    const convertedValue = convertSetIntoSingleNumber(selectedIDs as Set<number>);
    unstable_batchedUpdates(() => {
      if (convertedValue !== 2) {
        setConsent(0);
        object[consentValueKey] = defaultObject[consentValueKey];
      }
      setGDPR(convertedValue);
      object[valueKey] = convertedValue;
    });
  };

  const handleApplyConsent = (selectedIDs: Set<number | string>) => {
    const convertedValue = convertSetIntoSingleNumber(selectedIDs as Set<number>);
    setConsent(convertedValue);
    object[consentValueKey] = convertedValue;
  };

  return (
    <Rows gap={spacing.small}>
      <Row noPadding>
        <IndependentSelect
          handleApplySelect={handleApplyGDPR}
          isSelectionRequired={true}
          listLabel='GDPR'
          options={lists.GDPR}
          placeholder='Select GDPR Value'
          selectedLimit={1}
          selectedOptionIDs={new Set(selectedOptionIDsArray)}
          singularLabel='GDPR Value'
          key='GDPR'
          disableSort={true}
          maxWidth={480}
        />
      </Row>
      {gdpr === 2 && (
        <Row noPadding>
          <Cols
            gap={spacing.base}
            style={{ justifyContent: 'space-between', alignItems: 'center', width: '480px' }}
          >
            <Col>
              <Text small>GDPR Consent</Text>
            </Col>
            <Col flex style={{ maxWidth: '480px' }}>
              <IndependentSelect
                handleApplySelect={handleApplyConsent}
                isSelectionRequired={true}
                listLabel='GDPR'
                options={lists.GDPRConsent}
                placeholder='Select GDPR Consent Value'
                selectedLimit={1}
                selectedOptionIDs={new Set(selectedConsentIDsArray)}
                singularLabel='GDPR Consent Value'
                key='GDPRConsent'
                disableSort={true}
                maxWidth={480}
              />
            </Col>
          </Cols>
        </Row>
      )}
    </Rows>
  );
};
